import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

// Admin panel must always see fresh data: bypass browser/CDN HTTP caches by
// adding a timestamp param to GET requests made from /admin routes.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (method === "get" && typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
    config.params = { ...(config.params || {}), _ts: Date.now() };
  }
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

// Entity fetch that tells a REAL missing page apart from a flaky request.
//
// Previously every page did `.catch(() => setNotFound(true))`, so a single
// timeout / dropped connection rendered the 404 view — which emits
// `noindex` and reports the URL to the 404 tracker. That turned transient
// blips into "Excluded by noindex" in Search Console and thousands of phantom
// rows in Admin → Redirects. Only 404/410 means gone; everything else is
// retried and then surfaced as a load error (no noindex, no 404 report).
export async function getEntity(path, { tries = 3, params } = {}) {
  for (let attempt = 0; attempt < tries; attempt++) {
    try {
      const res = await api.get(path, params ? { params } : undefined);
      return { data: res.data };
    } catch (err) {
      const status = err.response?.status;
      if (status === 404 || status === 410) return { missing: true };
      if (attempt === tries - 1) return { error: true };
      await new Promise((r) => setTimeout(r, 500 * (attempt + 1)));
    }
  }
  return { error: true };
}

export function formatApiErrorDetail(detail) {  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
